import React from 'react';
import { useGetContributionInfoQuery } from '../../api/apiSlice';
import Screen from '../../components/fragments/Screen';
import CardHome from '../../components/legacy/CardHome';

export default function ContributionScreen() {
    const { data, isFetching } = useGetContributionInfoQuery();
    const { other } = data?.available || {};

    return (
        <Screen title="Contribution">
            <CardHome title={'M-PESA'} link={'/contribution/mpesa'} full />
            {!!(!isFetching && other) && (
                <CardHome title="Other" link="https://google.com" full blank />
            )}
        </Screen>
    );
}
